<template>
  <div class="select-button-area" :class="{ historyMode: isHistory }">
    <div class="card-result">
      <div class="left">
        <div class="result-rows">
          <div class="result-row">
            <div>{{ t('コインへ') }}</div>
          <div class="count">{{ returnItemCount }}</div>
          </div>
          <div class="result-row">
            <div v-if="hasPhysicalContent && hasDigitalContent">{{ t('発送') }}<br>{{ t('ダウンロード') }}</div>
            <div v-else-if="hasDigitalContent">{{ t('ダウンロード') }}</div>
            <div v-else>{{ t('発送') }}</div>
          <div class="count">{{ sendItemCount }}</div>
          </div>
          <div class="result-row">
            <div>{{ t('Xmarketへ販売') }}</div>
          <div class="count">{{ marketItemCount }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <div v-if="!isHistory" class="notice text-green">
          {{ t('1タップで「発送依頼」、2タップで「Xmarketへ出品」となります。') }}
        </div> -->
        <div class="total-coin-area">
          <div class="total-coin-title">{{ t('コインへの合計還元数') }}</div>
          <div class="total-coin">
            <img src="/img/star_coin.webp" alt="">
            <div class="coin">{{ returnPointTotal }} Coin</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="!isHistory" class="notice text-red">
      {{ t('マーケットへ出品ボタンが押された商品は、出品リストに表示されます。そこで販売価格を決定してマーケットへ出品してください。') }}
    </div> -->
    <div v-if="!isHistory" class="result-check-area">
      <div class="result-check" @click="$emit('decideLater')">
        {{ t('あとで決める') }}
      </div>
      <div class="result-check" @click="$emit('openConfirm')">
        {{ t('最終確認へ') }}
      </div>
    </div>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  name: 'SelectButtonArea',
  mixins: [t],
  props: {
    returnItemCount: {
      type: [Number, String],
    },
    sendItemCount: {
      type: [Number, String],
    },
    marketItemCount: {
      type: [Number, String],
    },
    returnPointTotal: {
      type: [Number, String],
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
    hasDigitalSend: {
      type: Boolean,
      default: false,
    },
    hasPhysicalSend: {
      type: Boolean,
      default: false,
    },
    hasDigitalContent: {
      type: Boolean,
      default: false,
    },
    hasPhysicalContent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.select-button-area {
  position: fixed;
  bottom: 0;
  width: 100vw;
  background-color: $white;
  z-index: 100;
  margin: 0 -10px;
  box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.5);
  font-weight: bold;
  color: $gray2;
  &.historyMode {
    padding-bottom: 10px;
  }
  .card-result {
    padding: 10px 0 0 0;
    display: flex;
    .left {
      width: 50%;
      padding: 0 0 10px 0px;
      display: flex;
      justify-content: center;
      .result-rows {
        width: 70%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .result-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 5px;
        .count {
          padding: 11px 0;
          width: 70px;
          background-color: #ffffff;
          text-align: center;
          border-radius: 5px;
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
        }
      }
    }
    .right {
      width: 50%;
      .total-coin-area {
        background-color: #ffffff;
        font-size: 30px;
        padding: 20px;
        border-radius: 10px;
        width: 85%;
        margin: 10px auto;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        .total-coin-title {
          text-align: center;
        }
        .total-coin {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 10px;
          img {
            width: 70px;
          }
          // .coin {
          //   padding: 5px 15px;
          //   background-color: $white;
          //   box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
          // }
        }
      }
    }
  }
  .result-check-area {
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 90%;
    margin: 0 auto 5px auto;
  }
  .result-check {
    width: 50%;
    background: linear-gradient(to top, #2a71b7, #308ecd, #37abe1 , #6ec5d7);
    box-shadow: 5px 5px 7px rgba(0, 0, 0, 0.5);
    color: $white;
    border-radius: 40px;
    padding: 7px 0;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notice {
    font-size: 12px;
    text-align: center;
  }
  .text-green {
    color: green;
  }
  .text-red {
    color: red;
    padding: 5px 0;
  }
}

@media screen and  (max-width: $tabletWidth) {
  .select-button-area {
    padding: 0;
    .card-result {
      .left {
        width: 60%;
        .result-rows {
          width: 78%;
          padding: 0;
          .result-row {
            font-size: 12px;
            .count {
              width: 36px;
              padding: 7px 0;
            }
          }
        }
      }
      .right {
        width: 49%;
        .total-coin-area {
          font-size: 15px;
          width: 89%;
          padding: 7px;
          .total-coin {
            img {
              width: 50px;
            }
          }
        }
      }
    }
    .notice {
      font-size: 6px;
    }
    .result_check {
      font-size: 16px;
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .select-button-area {
    padding: 0;
    .card-result {
      .left {
        .result-rows {
          width: 96%;
          .result-row {
            font-size: 12px;
            .count {
              width: 36px;
              padding: 7px 0;
            }
          }
        }
      }
    }
  }
}
</style>
